import { useFormContext } from "react-hook-form";
import { Checkbox } from "@material-tailwind/react";

// Controlled checkbox bound to a set-of-ids array field (`name`). The
// checked state is derived from the form value and written back with
// setValue so the raw id types reach the payload untouched (a registered
// checkbox group would stringify). Checking concat-enables the id;
// unchecking filters it back out.
export default function RHFSetCheckbox({ name, value, ...props }) {
    const { setValue, watch } = useFormContext();
    const selected = watch(name) || [];

    return (
        <Checkbox
            name={name}
            type="checkbox"
            value={value}
            {...props}
            checked={selected.includes(value)}
            onChange={(e) => {
                if (e.target.checked) {
                    setValue(name, selected.concat(value), {
                        shouldDirty: true,
                    });
                } else {
                    setValue(
                        name,
                        selected.filter((id) => id !== value),
                        { shouldDirty: true },
                    );
                }
            }}
        />
    );
}
